// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

// Define a service using a base URL and expected endpoints
export const contributionsApi = createApi({
  reducerPath: "contributionsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_RESSOURCES,
  }),
  tagTypes: ["CONTRIBUTIONS"],
  endpoints: (builder) => ({
    getContributions: builder.query<
      any,
      { profId: string; self: boolean; page?: number }
    >({
      query: (params) =>
        `contributions?profId=${params?.profId}&self=${params?.self}&page=${params?.page || 1
        }&classe=&search=`,
      providesTags: ["CONTRIBUTIONS"],
    }),

    deleteContribution: builder.mutation<any, string>({
      query: (idContribution) => {
        return {
          url: `/contributions/${idContribution}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["CONTRIBUTIONS"],
    }),

    changeContributionState: builder.mutation<any, any>({
      query: (values) => {
        return {
          url: `/contributions/${values?.idContribution}/changeEtat`,
          method: "PATCH",
          body: {
            action: values?.action,
          },
        };
      },
      invalidatesTags: ["CONTRIBUTIONS"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetContributionsQuery,
  useDeleteContributionMutation,
  useChangeContributionStateMutation,
} = contributionsApi;
